module.exports = __webpack_public_path__ + "img/4-Intersection 2.1a266a49.png";